import { Component, inject } from '@angular/core';
import { ORDER_LINK } from './order-link';
import { SalesOrderTableCustomComponentDirective } from './sales-order-table-custom.component';

@Component({
  selector: 'sales-ui-order-id-cell',
  template: '<a [routerLink]="orderLink(element)" class="title">{{ element.orderId}}</a>',
  styles: [
    `
      .title {
        font-size: 14px;
        font-weight: 500;
      }
    `,
  ],
})
export class OrderIdCellComponent extends SalesOrderTableCustomComponentDirective {
  orderLink = inject(ORDER_LINK);
}
